import { useEffect } from 'react';
import { useUIStore } from '../../stores/ui-store.ts';

function applyDark(root: HTMLElement, dark: boolean) {
  root.classList.toggle('dark', dark);
  root.style.colorScheme = dark ? 'dark' : 'light';
}

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const theme = useUIStore((s) => s.theme);

  useEffect(() => {
    const root = document.documentElement;

    if (theme === 'system') {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      const apply = () => applyDark(root, mq.matches);
      apply();
      mq.addEventListener('change', apply);
      return () => mq.removeEventListener('change', apply);
    }

    applyDark(root, theme === 'dark');
  }, [theme]);

  return <>{children}</>;
}
